<div class="carousel-container">
    <button mat-icon-button (click)="owlCar.prev()">
        <mat-icon>arrow_back_ios</mat-icon>
    </button>

    <div style="flex: 1; overflow: hidden;">
        <owl-carousel-o #owlCar class="carousel" [options]="options">
          @for (tile of (tile$ | ngrxPush); track tile.id) {
            <ng-template carouselSlide>
                <div class="mbp-tile">
                    <img [ngClass]="(tile.selected ? 'carousel-img selected' : 'carousel-img')"
                         (click)="onClick(tile)" [src]="tile.imgCaroussel | ImagePipe : tile.dirImg : 'svg'">
                </div>
            </ng-template>
          }
        </owl-carousel-o>
    </div>
    <button mat-icon-button (click)="owlCar.next()">
        <mat-icon>arrow_forward_ios</mat-icon>
    </button>
</div>
